import { usePrint } from '@abyss/web/hooks/usePrint';
import { globalCss } from '@abyss/web/tools/styled';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useFeatureFlag } from '../useFeatureFlag';

const printGlobalStyles = globalCss({
  '@media print': {
    '#global-header': {
      display: 'none',
    },
    '#global-main': {
      display: 'none',
    },
    '#global-footer': {
      display: 'none',
    },
  },
});

export const usePrintPSX = () => {
  const [enablePSXPrintSolution] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PRINT,
  ]);
  const print = usePrint();
  const printPSXPage = () => {
    if (enablePSXPrintSolution) {
      printGlobalStyles();
      window.print();
    } else {
      print.printPage(() => {}, {
        openNewWindow: false,
      });
    }
  };
  return { printPSXPage };
};
